<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/normalize.png" /></div>
      <p>Normalize.css</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/normalize/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '8.0.0',
        linkList: [
          ur + '8.0.0/normalize.css',
          ur + '8.0.0/normalize.min.css'
        ]
      }, {
        label: '7.0.0',
        linkList: [
          ur + '7.0.0/normalize.css',
          ur + '7.0.0/normalize.min.css'
        ]
      }, {
        label: '6.0.0',
        linkList: [
          ur + '6.0.0/normalize.css',
          ur + '6.0.0/normalize.min.css'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListNormalize.vue